module.exports = __webpack_public_path__ + "media/images/coupon/img-guttozutto-ba15715a106c445a1aaba53ebdcc0546.png";